import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { STORAGE_KEYS } from 'src/app/shared/utility/constants';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  public browserRefresh = false;

  constructor(
    private readonly http: HttpClient,
    private readonly localStorageService: LocalStorageService
  ) {}

  initiateApiRequest = (
    method: 'DELETE' | 'GET' | 'HEAD' | 'JSONP' | 'OPTIONS' | 'POST' | 'PUT',
    url: string,
    body: any = null,
    contentType = 'application/json',
    responseType: 'arraybuffer' | 'blob' | 'text' | 'json' = 'json',
    queryParams: HttpParams = new HttpParams()
  ): Observable<any> => {
    return this.getHttpRequest(
      method,
      url,
      body,
      responseType,
      contentType,
      queryParams
    );
  };

  public getHttpRequest = (
    method: 'DELETE' | 'GET' | 'POST' | 'PUT' | 'HEAD' | 'JSONP' | 'OPTIONS',
    url: string,
    body: any,
    responseType: 'arraybuffer' | 'blob' | 'text' | 'json' = 'json',
    contentType = 'application/json',
    queryParams: any
  ): Observable<any> => {
    let headers = new HttpHeaders();
    const token = this.localStorageService.getItem(STORAGE_KEYS.JWT_TOKEN);
    headers = headers.set('authorization', token ?? '');
    return this.http.request(method, url, {
      body,
      headers,
      responseType,
      params: queryParams,
    });
  };

  /**
   * `reportProgress` opts into HttpEvents so a caller can render upload progress.
   * Off by default — existing callers keep receiving just the response body.
   */
  public uploadFile = (
    url: string,
    file: string,
    reportProgress = false
  ): Observable<any> => {
    const formData = new FormData();
    formData.append('fileName', file);
    const headers = new HttpHeaders({
      'x-ms-blob-type': 'BlockBlob',
    });
    return this.http.put(url, formData, {
      headers,
      responseType: 'text',
      reportProgress,
      observe: reportProgress ? 'events' : 'body',
    } as { headers: HttpHeaders; responseType: 'text' });
  };

  public authorizeToken = (
    url: string,
    accessToken: string,
    ipAddress: string
  ): Observable<any> => {
    const headers = new HttpHeaders({
      authorization: accessToken,
    });
    return this.http.get(url + `/${ipAddress}`, {
      headers,
      responseType: 'json',
    });
  };

  public ipAddress = (url: string): Observable<any> => {
    return this.http.get(url, {
      responseType: 'json',
    });
  };

  public uploadAPFile = (url: string, file: string): Observable<any> => {
    const formData = new FormData();
    formData.append('file', file);
    const token = this.localStorageService.getItem(STORAGE_KEYS.JWT_TOKEN);
    const headers = new HttpHeaders({
      'x-ms-blob-type': 'BlockBlob',
      authorization: token ?? '',
    });
    return this.http.post(url, formData, {
      headers,
      responseType: 'text',
    });
  };
}
